/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_Options_LabelInputs */



/**
* | output |
* | --- |
* | "Include Fields" |
*
* @param {Transcript_Export_Include_Options_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_options_label = /** @type {((inputs?: Transcript_Export_Include_Options_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_Options_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Include Fields")
	if (locale === "de") return /** @type {LocalizedString} */ ("Include Fields")
	if (locale === "it") return /** @type {LocalizedString} */ ("Include Fields")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Include Fields")
	if (locale === "es") return /** @type {LocalizedString} */ ("Include Fields")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Include Fields")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Include Fields")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Include Fields")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Include Fields")
	return /** @type {LocalizedString} */ ("Include Fields")
});